const thumbsDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M13.09 9.6H16V0h-2.91m-2.908 0H3.636c-.603 0-1.12.4-1.338.976L.102 6.616A1.72 1.72 0 0 0 0 7.2v1.6c0 .424.153.831.426 1.131.273.3.643.469 1.029.469h4.589l-.691 3.656c-.015.08-.022.16-.022.248 0 .336.124.632.32.848l.77.848 4.786-5.272c.27-.288.43-.688.43-1.128v-8c0-.424-.154-.831-.427-1.131A1.39 1.39 0 0 0 10.182 0"/></svg>',
};

export { thumbsDown as default };
